import omit from 'lodash/omit';
import { useMe } from 'shared/hooks';
export var useIsPartOfCareTeam = function (careTeam) {
    var _a, _b, _c;
    var me = useMe().data;
    var careTeamMemberEntries = omit((_c = (_b = (_a = careTeam === null || careTeam === void 0 ? void 0 : careTeam.user) === null || _a === void 0 ? void 0 : _a.member) === null || _b === void 0 ? void 0 : _b.care_team) !== null && _c !== void 0 ? _c : {}, 'id');
    return Object.keys(careTeamMemberEntries).some(function (careTeamMemberKey) {
        var _a, _b, _c;
        return !!((_a = careTeamMemberEntries[careTeamMemberKey]) === null || _a === void 0 ? void 0 : _a.id) &&
            ((_b = careTeamMemberEntries[careTeamMemberKey]) === null || _b === void 0 ? void 0 : _b.id) ===
                ((_c = me === null || me === void 0 ? void 0 : me.care_provider) === null || _c === void 0 ? void 0 : _c.id);
    });
};
